import { render } from "./ColumnCount.vue?vue&type=template&id=f2509fe6&scoped=true&ts=true"
import script from "./ColumnCount.vue?vue&type=script&lang=ts"
export * from "./ColumnCount.vue?vue&type=script&lang=ts"

import "./ColumnCount.vue?vue&type=style&index=0&id=f2509fe6&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2509fe6"]])

export default __exports__